import Input from "components/OldInput";
import { PrettyState } from "constants/orderState";
import Context from "context/Global";
import { match } from "helpers/Match";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Portal } from "react-portal";
import { Link, withRouter } from "react-router-dom";
import Api from "services/Api/Api";
import styled from "styled-components/macro";
import BookDialog from "./BookDialog";
import CompareDialog from "./CompareDialog";
import { getProductName } from "./Helpers";
import useCreateDraftsStore from "../../../Drafts/Create/createDraftsStore";
import { getIntegrationImage } from "../../../../helpers/Logos";
import { getIntegrationName } from "../../../../helpers/Integrations";

let Container = styled.tr`
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    text-decoration: none;
    color: #000;

    flex-shrink: 0;

    &:last-child {
        border-bottom: 0;
    }

    > .notifications {
        width: 90px;
        min-width: 90px;

        > .notification {
            position: relative;
            display: inline-flex;
            justify-content: flex-start;
            align-items: center;

            > .text {
                opacity: 0;
                pointer-events: none;
                position: absolute;
                transition: all 0.3s ease;
                background: #fff;
                white-space: nowrap;
                display: flex;
                justify-content: center;
                align-items: center;
                left: calc(100% + 8px);
                box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.1);
                padding: 4px 12px;
                border-radius: 4px;
                z-index: 100;
            }

            &:hover {
                .text {
                    opacity: 1;
                    pointer-events: all;
                }
            }

            > .icon {
                border-radius: 100%;
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48px;
                height: 48px;
                color: #fff;

                > svg {
                    width: 100%;
                    height: 100%;
                }
            }

            &.issue {
                > .icon {
                    background: #e57c1b;
                }
            }

            &.information {
                > .icon {
                    background: #72c3ed;
                }
            }

            &.noPickup {
                > .icon {
                    > svg {
                        margin-left: 2px;
                        margin-top: 4px;
                    }
                }
            }

            &.notPickedUp {
                > .icon {
                    > svg {
                        margin-left: 2px;
                        margin-top: 4px;
                    }
                }
            }
            &.exception {
                > .icon {
                    > svg {
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }

    > .notification {
        padding-left: 1em;
        width: 48px;
        box-sizing: border-box;
        padding-right: 1em;
    }

    .date {
        > .imported {
            white-space: nowrap;
            padding: 0.5rem 1rem 0 0;
        }
        > .created {
            white-space: nowrap;
            padding: 0 1rem 0.5rem 0;
            font-size: 0.7rem;
        }
    }
    .integrationType {
        > img {
            margin-right: 1rem;
            width: 80px;
            max-height: 30px;
            object-fit: contain;
        }
    }
    .reference {
        white-space: nowrap;
    }

    .sender,
    .recipient {
        > .wrapper {
            display: flex;
            flex-direction: column;
            padding: 0.5rem 1rem 0.5rem 0;

            > .receiver {
                font-weight: bold;
                white-space: nowrap;
            }

            > .location {
                white-space: nowrap;
            }
        }
    }

    .menu {
        width: 100px;

        > .button {
            color: rgba(0, 0, 0, 0.5);
            padding: 1rem;
            padding-left: 2rem;
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;

            &:hover {
                color: rgba(0, 0, 0, 1);
            }

            > .menu-wrapper {
                pointer-events: none;
                display: flex;
                justify-content: center;
                align-items: center;

                > .menu-background {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                }

                > .menu-container {
                    position: absolute;
                    background: #fff;
                    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
                    right: 0;
                    transition: all 0.3s ease;
                    opacity: 0;
                    z-index: 101;
                    transform: translateY(10px);

                    > .option {
                        padding: 1rem;
                        white-space: nowrap;
                        color: #000;

                        &:hover {
                            background: #eaeaea;
                        }
                    }
                }

                &.is-visible {
                    pointer-events: all;

                    > .menu-container {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            }
        }
    }

    > .delete {
        > .wrapper {
            width: 16px;
            height: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #aaa;

            &:hover {
                color: #555;
            }

            > svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    > .title {
        font-size: 16px;
    }
    > .book {
        > .wrapper {
            display: flex;
            gap: 1rem;
        }
    }

    &:hover {
        background: rgba(0, 0, 0, 0.02);
    }
`;

function Component({ history, ...props }) {
    const [order, setOrder] = useState(props.order);
    const [bookingState, setBookingState] = useState(props.order);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [isArchiving, setIsArchiving] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showCompareView, setShowCompareView] = useState(false);
    const [bookWithTemplate, setBookWithTemplate] = useState(null);
    const context = useContext(Context);
    const { setReceiverPaysContactId } = useCreateDraftsStore();

    const templatePickerRef = useRef();

    useEffect(() => {
        setOrder(props.order);
    }, [props.order]);
    let exception = null;
    let pickupInPast = false;
    let noPickup = false;
    if (order.hasError) {
        exception = order.messages.find((message) => {
            return message.type === "error";
        });
    } else if (
        order.state === "APPROVED" &&
        order.confirmationNumber &&
        moment().diff(moment(order.pickupDate)) > 0
    ) {
        pickupInPast = true;
    } else if (order.state === "APPROVED" && !order.confirmationNumber) {
        noPickup = true;
    }

    function renderOrderState(order) {
        let response = [];

        if (order.state === "DELIVERED") {
            response.push(
                <div>
                    Levererad {moment(order.deliveryDate).format("YYYY-MM-DD")}
                </div>,
            );
        } else if (
            order.state === "APPROVED" &&
            order.confirmationNumber &&
            order.pickupDate
        ) {
            if (
                moment(order.pickupDate).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
            ) {
                response.push(
                    <div>
                        Bokades för upphämtning{" "}
                        {moment(order.pickupDate).calendar(null, {
                            sameDay: "[idag]",
                            lastDay: "[igår]",
                            lastWeek: "[i] dddd[s]",
                            sameElse: "LL",
                        })}
                        .
                    </div>,
                );
            } else {
                response.push(
                    <div>
                        Bokad för upphämtning{" "}
                        {moment(order.pickupDate).calendar(null, {
                            sameDay: "[idag]",
                            nextDay: "[imorgon]",
                            nextWeek: "[på] dddd",
                            sameElse: "LL",
                        })}
                        .
                    </div>,
                );
            }
        } else if (order.state === "APPROVED") {
            response.push(<div>Ingen upphämtning bokad!</div>);
        } else if (order.state === "REJECTED") {
            response.push(<div>Bokningen misslyckades!</div>);
        } else {
            response.push(<div>{PrettyState(order.state)}</div>);
        }

        return response;
    }

    function getMessageText(message) {
        switch (message.code) {
            case "DELIVERY_FAILED": {
                return "Leveransen misslyckades. Se detaljer och kontakta kundservice vid behov.";
            }
            case "MISROUTED": {
                return "Försändelsen försenas pga felsortering.";
            }
            case "MISSING_CUSTOMS": {
                return "Saknas eller felaktiga tull-dokument. Var god kontakta kundservice!";
            }
            case "DELIVERY_FAILED": {
                return "Misslyckat leveransförsök. Inväntar nästa utkörningstillfälle.";
            }
            case "INVALID_ADDRESS": {
                return "Felaktig leveransadress. Var god kontakta kundservice!";
            }
            case "CHANGED": {
                return "Ändring av transportuppdrag. Kontakta kundservice för detaljer.";
            }
            case "INCOMPLETE": {
                return "Saknas ellerfelaktiga dokument. Var god kontakta kundservice!";
            }
            case "RECLAIMED": {
                return "Försändelsen är reklamerad. Var god kontakta kundservice!";
            }
            case "REFUSED": {
                return "Mottagaren vägrar ta emot godset. Sändningen returneras till avsändaren.";
            }
            default: {
                return message.text;
            }
        }
    }

    function openMenu(ev) {
        ev.stopPropagation();
        setMenuIsOpen(true);
    }

    function closeMenu(ev) {
        ev.stopPropagation();
        setMenuIsOpen(false);
    }

    async function duplicateOrder() {
        setReceiverPaysContactId(null);
        if (order.receiverPays) {
            setReceiverPaysContactId(order.receiverPays.contactId);
        }
        context.updateOrder({
            packages: order.packages,
            sender: order.route.from,
            receiver: order.route.to,
            information: order.information,
            customsInvoice: null,
        });
        history.push(`/create/imported/${order.id}`);
    }

    async function archiveOrder(ev) {
        ev.stopPropagation();
        setMenuIsOpen(false);
        setIsArchiving(true);
        await Api.archiveOrder({
            orderId: order.id,
        });

        props.refresh();
    }

    if (!order) {
        return null;
    }

    function showBookDirect(order) {
        const integration = context.user.customer.integrations?.find(
            (integration) => {
                return integration.id === order.customerIntegrationId;
            },
        );

        return !!integration?.data.templates;
    }

    function getProductOptions(order) {
        const integration = context.user.customer.integrations.find(
            (integration) => {
                return integration.id === order.customerIntegrationId;
            },
        );

        return [
            {
                title: "Boka Direkt",
                value: "",
            },
        ].concat(
            integration.data.templates?.map((template) => {
                return {
                    title: getProductName(template.productCode),
                    value: template.productCode,
                };
            }),
        );
    }

    function openBookingDialog() {
        const t = context.user.customer.integrations
            .find((integration) => {
                return integration.id === order.customerIntegrationId;
            })
            .data.templates?.find((template) => {
                return (
                    template.productCode === templatePickerRef.current.value()
                );
            });

        if (t) {
            if (t.productCode.toLowerCase().indexOf("dhl") === 0) {
                t.service = "DHL";
            } else if (t.productCode.toLowerCase().indexOf("fedex") === 0) {
                t.service = "Fedex";
            } else if (t.productCode.toLowerCase().indexOf("ups") === 0) {
                t.service = "UPS";
            } else if (t.productCode.toLowerCase().indexOf("tnt") === 0) {
                t.service = "TNT";
            }
        }

        setBookWithTemplate(t);
    }

    function stateChanged(state) {
        setBookingState(state);
    }

    function onDelete(ev) {
        ev.stopPropagation();
        props.onDelete(order);
    }

    return (
        <Container
            href={`/create/imported/${order.id}`}
            onClick={() => {
                history.push(`/create/imported/${order.id}`);
            }}
        >
            <td className="integrationType">
                <img
                    src={`/images/icons/${getIntegrationImage(
                        order.integrationType,
                    )}`}
                />
            </td>
            <td className="externalId">{order.externalId}</td>
            <td className="reference">{order.reference}</td>
            <td className="date">
                <div className="imported">
                    {moment(order.imported || order.created).calendar(null, {
                        sameDay: "[Idag]",
                        lastDay: "[Igår]",
                        lastWeek: "[I] dddd[s]",
                        sameElse: "LL",
                    })}
                </div>
                {order.created && (
                    <div className="created">
                        Skapad i {getIntegrationName(order.integrationType)}{" "}
                        {moment(order.created).calendar(null, {
                            sameDay: "[Idag]",
                            lastDay: "[Igår]",
                            lastWeek: "[I] dddd[s]",
                            sameElse: "LL",
                        })}
                    </div>
                )}
            </td>
            <td className="sender">
                <div className="wrapper">
                    <div className="receiver">{order.senderName}</div>
                    <div className="location">
                        {[order.senderCity, order.senderCountryCode]
                            .filter((v) => v)
                            .join(", ")}
                    </div>
                </div>
            </td>
            <td className="recipient">
                <div className="wrapper">
                    <div className="receiver">
                        {order.data.receiver.contact.private
                            ? order.data.receiver.contact.name
                            : order.recipientName}
                    </div>
                    <div className="location">
                        {[order.recipientCity, order.recipientCountryCode]
                            .filter((v) => v)
                            .join(", ")}
                    </div>
                </div>
            </td>
            <td className="book" onClick={(ev) => ev.stopPropagation()}>
                {bookingState.status === "BOOKING" && (
                    <div className="wrapper">Bokar...</div>
                )}
                {bookingState.status === "BOOKED" && (
                    <div className="wrapper">
                        <Link to={`/orders/${bookingState.order.id}`}>
                            {bookingState.order.trackingNumber}
                        </Link>
                    </div>
                )}
                {bookingState.status === "FAILED" && (
                    <div className="wrapper">Bokningen misslyckades.</div>
                )}
                {!bookingState.status && showBookDirect(order) && (
                    <>
                        <div className="wrapper">
                            {/* <button className="c-button c-button--raised" onClick={() => setShowCompareView(true)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="0.266667in" height="0.266667in" viewBox="0 0 24 24"><path id="Selection" fill="currentColor" d="M 2.70,0.00 C 2.70,0.00 3.84,0.00 3.84,0.00 3.99,0.00 4.15,0.06 4.30,0.10 4.30,0.10 5.26,0.36 5.26,0.36 5.26,0.36 8.17,1.15 8.17,1.15 8.17,1.15 12.67,2.37 12.67,2.37 12.67,2.37 16.97,3.54 16.97,3.54 16.97,3.54 18.86,4.06 18.86,4.06 18.86,4.06 20.29,4.44 20.29,4.44 20.29,4.44 21.04,4.65 21.04,4.65 21.09,4.66 21.25,4.70 21.27,4.73 21.29,4.75 21.29,4.79 21.29,4.81 21.29,4.81 21.29,8.78 21.29,8.78 21.29,8.81 21.28,8.84 21.30,8.87 21.31,8.90 21.37,8.95 21.39,8.98 21.39,8.98 21.59,9.18 21.59,9.18 21.59,9.18 22.52,10.12 22.52,10.12 22.52,10.12 23.64,11.26 23.64,11.26 23.64,11.26 23.87,11.49 23.87,11.49 23.96,11.58 24.00,11.59 24.00,11.72 24.00,11.72 24.00,12.96 24.00,12.96 24.00,12.96 17.36,12.96 17.36,12.96 17.36,12.96 17.36,11.73 17.36,11.73 17.36,11.60 17.40,11.59 17.49,11.50 17.49,11.50 17.72,11.27 17.72,11.27 17.72,11.27 18.84,10.14 18.84,10.14 18.84,10.14 19.76,9.20 19.76,9.20 19.76,9.20 19.96,9.00 19.96,9.00 19.99,8.98 20.04,8.93 20.05,8.90 20.07,8.87 20.06,8.83 20.06,8.80 20.06,8.80 20.06,5.94 20.06,5.94 20.06,5.94 19.88,5.89 19.88,5.89 19.88,5.89 19.64,5.83 19.64,5.83 19.64,5.83 19.57,5.81 19.57,5.81 19.57,5.81 19.41,5.76 19.41,5.76 19.41,5.76 18.50,5.52 18.50,5.52 18.50,5.52 18.39,5.49 18.39,5.49 18.39,5.49 18.32,5.47 18.32,5.47 18.32,5.47 17.92,5.36 17.92,5.36 17.92,5.36 17.82,5.33 17.82,5.33 17.82,5.33 17.69,5.30 17.69,5.30 17.69,5.30 17.61,5.27 17.61,5.27 17.61,5.27 17.44,5.23 17.44,5.23 17.44,5.23 17.33,5.20 17.33,5.20 17.33,5.20 17.23,5.18 17.23,5.18 17.23,5.18 17.15,5.15 17.15,5.15 17.15,5.15 16.85,5.07 16.85,5.07 16.85,5.07 16.75,5.05 16.75,5.05 16.75,5.05 16.68,5.02 16.68,5.02 16.68,5.02 16.52,4.99 16.52,4.99 16.52,4.99 16.37,4.94 16.37,4.94 16.37,4.94 16.14,4.87 16.14,4.87 16.14,4.87 16.05,4.86 16.05,4.86 16.05,4.86 15.90,4.81 15.90,4.81 15.90,4.81 15.58,4.73 15.58,4.73 15.58,4.73 15.43,4.68 15.43,4.68 15.43,4.68 15.35,4.67 15.35,4.67 15.35,4.67 15.24,4.63 15.24,4.63 15.24,4.63 14.88,4.54 14.88,4.54 14.88,4.54 14.75,4.50 14.75,4.50 14.75,4.50 14.65,4.48 14.65,4.48 14.65,4.48 14.57,4.45 14.57,4.45 14.57,4.45 14.40,4.41 14.40,4.41 14.40,4.41 14.26,4.36 14.26,4.36 14.26,4.36 14.18,4.35 14.18,4.35 14.18,4.35 14.09,4.32 14.09,4.32 14.09,4.32 13.93,4.28 13.93,4.28 13.93,4.28 13.79,4.23 13.79,4.23 13.79,4.23 13.71,4.22 13.71,4.22 13.71,4.22 13.59,4.18 13.59,4.18 13.59,4.18 13.48,4.16 13.48,4.16 13.48,4.16 13.39,4.13 13.39,4.13 13.39,4.13 13.23,4.09 13.23,4.09 13.23,4.09 13.11,4.05 13.11,4.05 13.11,4.05 13.01,4.03 13.01,4.03 13.01,4.03 12.88,3.99 12.88,3.99 12.88,3.99 12.88,22.71 12.88,22.71 12.88,22.71 17.58,22.71 17.58,22.71 17.58,22.71 17.58,24.00 17.58,24.00 17.58,24.00 6.36,24.00 6.36,24.00 6.36,24.00 6.36,22.71 6.36,22.71 6.36,22.71 11.06,22.71 11.06,22.71 11.06,22.71 11.06,9.97 11.06,9.97 11.06,9.97 11.06,3.60 11.06,3.60 11.06,3.60 11.04,3.50 11.04,3.50 11.04,3.50 10.92,3.46 10.92,3.46 10.92,3.46 10.67,3.39 10.67,3.39 10.67,3.39 10.55,3.36 10.55,3.36 10.55,3.36 10.44,3.33 10.44,3.33 10.44,3.33 10.36,3.31 10.36,3.31 10.36,3.31 10.19,3.26 10.19,3.26 10.19,3.26 10.06,3.22 10.06,3.22 10.06,3.22 9.97,3.20 9.97,3.20 9.97,3.20 9.83,3.16 9.83,3.16 9.83,3.16 9.74,3.15 9.74,3.15 9.74,3.15 9.67,3.12 9.67,3.12 9.67,3.12 9.49,3.07 9.49,3.07 9.49,3.07 9.39,3.04 9.39,3.04 9.39,3.04 9.27,3.02 9.27,3.02 9.27,3.02 9.20,2.99 9.20,2.99 9.20,2.99 9.01,2.94 9.01,2.94 9.01,2.94 8.90,2.91 8.90,2.91 8.90,2.91 8.80,2.89 8.80,2.89 8.80,2.89 8.72,2.86 8.72,2.86 8.72,2.86 8.56,2.83 8.56,2.83 8.56,2.83 8.42,2.78 8.42,2.78 8.42,2.78 8.19,2.72 8.19,2.72 8.19,2.72 8.10,2.70 8.10,2.70 8.10,2.70 7.78,2.60 7.78,2.60 7.78,2.60 7.63,2.57 7.63,2.57 7.63,2.57 7.48,2.52 7.48,2.52 7.48,2.52 7.40,2.51 7.40,2.51 7.40,2.51 7.29,2.47 7.29,2.47 7.29,2.47 6.93,2.38 6.93,2.38 6.93,2.38 6.80,2.34 6.80,2.34 6.80,2.34 6.70,2.32 6.70,2.32 6.70,2.32 6.63,2.29 6.63,2.29 6.63,2.29 6.45,2.25 6.45,2.25 6.45,2.25 6.32,2.21 6.32,2.21 6.32,2.21 6.22,2.19 6.22,2.19 6.22,2.19 6.14,2.16 6.14,2.16 6.14,2.16 5.97,2.12 5.97,2.12 5.97,2.12 5.83,2.08 5.83,2.08 5.83,2.08 5.75,2.06 5.75,2.06 5.75,2.06 5.64,2.02 5.64,2.02 5.64,2.02 5.52,2.00 5.52,2.00 5.52,2.00 5.38,1.95 5.38,1.95 5.38,1.95 5.28,1.93 5.28,1.93 5.28,1.93 5.15,1.89 5.15,1.89 5.15,1.89 5.06,1.87 5.06,1.87 5.06,1.87 4.72,1.77 4.72,1.77 4.72,1.77 4.45,1.70 4.45,1.70 4.45,1.70 4.36,1.68 4.36,1.68 4.36,1.68 4.29,1.66 4.29,1.66 4.29,1.66 3.92,1.56 3.92,1.56 3.92,1.56 3.92,3.87 3.92,3.87 3.92,3.90 3.92,3.94 3.94,3.96 3.95,4.00 4.00,4.04 4.03,4.07 4.03,4.07 4.23,4.27 4.23,4.27 4.23,4.27 5.16,5.22 5.16,5.22 5.16,5.22 6.28,6.35 6.28,6.35 6.28,6.35 6.51,6.58 6.51,6.58 6.60,6.67 6.64,6.68 6.64,6.81 6.64,6.81 6.64,8.05 6.64,8.05 6.64,8.05 0.00,8.05 0.00,8.05 0.00,8.05 0.00,6.82 0.00,6.82 0.00,6.69 0.04,6.68 0.13,6.60 0.13,6.60 0.36,6.36 0.36,6.36 0.36,6.36 1.48,5.23 1.48,5.23 1.48,5.23 2.40,4.29 2.40,4.29 2.40,4.29 2.60,4.09 2.60,4.09 2.62,4.07 2.67,4.02 2.69,3.99 2.70,3.96 2.70,3.93 2.70,3.89 2.70,3.89 2.70,0.00 2.70,0.00 Z M 4.29,6.81 C 4.29,6.81 4.03,6.54 4.03,6.54 4.03,6.54 3.57,6.08 3.57,6.08 3.57,6.08 3.41,5.91 3.41,5.91 3.41,5.91 3.33,5.85 3.33,5.85 3.33,5.85 3.25,5.91 3.25,5.91 3.25,5.91 3.09,6.08 3.09,6.08 3.09,6.08 2.63,6.54 2.63,6.54 2.63,6.54 2.38,6.81 2.38,6.81 2.38,6.81 4.29,6.81 4.29,6.81 Z M 20.69,10.74 C 20.69,10.74 20.20,11.22 20.20,11.22 20.20,11.22 19.73,11.72 19.73,11.72 19.73,11.72 21.65,11.72 21.65,11.72 21.65,11.72 21.32,11.37 21.32,11.37 21.32,11.37 20.69,10.74 20.69,10.74 Z" /></svg>
                        </button> */}
                            <Input
                                ref={templatePickerRef}
                                type="dropdown"
                                placeholder="Boka direkt"
                                options={getProductOptions(order)}
                                onChange={setSelectedProduct}
                                value={null}
                            />
                            <button
                                className="c-button c-button--raised"
                                disabled={!selectedProduct}
                                onClick={openBookingDialog}
                            >
                                Boka
                            </button>
                        </div>
                        {showCompareView && (
                            <CompareDialog
                                order={order}
                                closeDialog={() => setShowCompareView(false)}
                            />
                        )}
                        {bookWithTemplate && (
                            <Portal>
                                <BookDialog
                                    order={order}
                                    template={bookWithTemplate}
                                    onStateChanged={stateChanged}
                                    closeDialog={() =>
                                        setBookWithTemplate(null)
                                    }
                                />
                            </Portal>
                        )}
                    </>
                )}
            </td>
            <td className="delete">
                <div className="wrapper" onClick={onDelete}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
                        />
                    </svg>
                </div>
            </td>
        </Container>
    );
}

export default withRouter(Component);
